<template>
  <div>
    <v-autocomplete
      :label="$t('components.checklists.checklistBoatSelector.selectBoat')"
      v-model="boat"
      :items="boatOptions"
      :menu-props="{ maxHeight: '400' }"
      @input.native="loadBoats()"
      :search-input.sync="boatSearch"
      persistent-hint
      color="primary"
      clearable
      autocomplete="off"
      hide-selected
      @change="handleChange"
      :disabled="disabled"
      :item-text="formattedBoatName"
      return-object
      no-filter
    >
      <template v-slot:item="{ item }">
        {{ formattedBoatName(item) }}
      </template>
      <template v-slot:selection="{ item }">
        {{ formattedBoatName(item) }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import api from "@/utils/api";

export default {
  props: {
    checklist: {
      type: Object,
      default: Object,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    boatOptions: [],
    boatSearch: "",
    boat: null,
    loading: true,
    timeout: null,
  }),

  created() {
    this.loadBoats(true);
  },
  methods: {
    formattedBoatName: (item) => {
      if (item) {
        return `${item.model.brand_name} ${item.model.model} #${item.slot_number}`;
      } else {
        return;
      }
    },
    handleChange(value = {}) {
      this.$emit("new:boat", value);
    },

    loadBoats(initalLoad = false) {
      const fetchBoats = () => {
        return new Promise((resolve, reject) => {
          this.boatSearch = this.boatSearch ? this.boatSearch : "";
          api
            .boatsAutocomplete(
              {
                search: this.boatSearch,
                autocomplete: true,
              },
              this.maintenanceContent
            )
            .then((resp) => {
              this.boatOptions = resp.data.results;
              resolve();
            });
        });
      };

      const initialLoad = () => {
        fetchBoats().then(() => {
          if (this.checklist.crm_boat_uuid !== null) {
            let crmBoat = this.boatOptions.find(
              (boat) => boat.uuid === this.checklist.crm_boat_uuid
            );
            if (typeof crmBoat !== "undefined") {
              this.boat = crmBoat;
            }
          }

          if (
            this.checklist.crm_boat !== null &&
            Object.keys(this.checklist.crm_boat).length !== 0
          ) {
            this.boatOptions.push(this.checklist.crm_boat);
            this.boat = this.checklist.crm_boat;
          }
        });
      };

      if (initalLoad) return initialLoad();

      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        return fetchBoats();
      }, 300); // delay
    },
  },
};
</script>
